import React, { Component } from "react";
import { Card, CardBody, Col, Button, ButtonToolbar } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import toastr from "toastr";
import { PulseLoader } from "react-spinners";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Zoom from '@material-ui/core/Zoom';
import { createReviewer } from '../../../../actions/createReviewerAction';
import "./styles.css";

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    width: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  }
});

class CreateReviewer extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
  };

  constructor() {
    super();
    this.state = {
      name: "",
      email: "",
      phone: "",
      password: "",
      loader: false
    };
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.reviewerAddStatus == "done") {
      this.setState({
        loader: false
      });
    } else if (nextProps.reviewerAddStatus == "error") { 
      this.setState({
        loader: false
      });
    }
  };

  onChangeHandler = e => {
    e.preventDefault();
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

    creatReviewer = e => {
        e.preventDefault();

        let { 
            name,
            email,
            phone,
            password
        } = this.state;

        if (name == "" || email == "" || phone == "" || password == "") {
            toastr.error("All fields are required!");
        } else {
            this.setState({
                loader: true
            });

            let data = {
                name,
                email,
                phone,
                password
            };

            this.props.createReviewer(data);
        }
    };

  render() {
    const { loader } = this.state;

    return (
      <Col md={12} lg={12} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Card className='card'>
          <CardBody>
            <h1>Create Reviewer</h1>
            <form className="form form--horizontal" onSubmit={this.creatReviewer}>
              
              <div className="form__form-group input-field">
                <span className="form__form-group-label">Name</span>
                <div className="form__form-group-field selectEmply">
                  <TextField
                    id='standard-full-width'
                    name="name"
                    type="text"
                    placeholder="Enter Reviewer's Name "
                    onChange={this.onChangeHandler}
                  />
                  <Tooltip TransitionComponent={Zoom} title="Enter the name of reviewer">
                    <IconButton className="helpButton">
                      {/* <img className="helpImage" src={HelpIcon} alt="help"/> */}
                      <i class="zmdi zmdi-help"></i>
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
              
              <div className="form__form-group input-field">
                <span className="form__form-group-label">Email</span>
                <div className="form__form-group-field selectEmply">
                  <TextField
                    name="email"
                    type="email"
                    placeholder="Enter Reviewer's Email"
                    onChange={this.onChangeHandler}
                  />
                  <Tooltip TransitionComponent={Zoom} title="Enter email for reviewer's login">
                    <IconButton className="helpButton">
                      {/* <img className="helpImage" src={HelpIcon} alt="help"/> */}
                      <i class="zmdi zmdi-help"></i>
                    </IconButton>
                  </Tooltip>
                </div>
              </div>

              <div className="form__form-group input-field">
                <span className="form__form-group-label">Phone</span>
                <div className="form__form-group-field selectEmply">
                  <TextField
                    name="phone"
                    type="text"
                    placeholder="Enter Reviewer's Phone Number"
                    onChange={this.onChangeHandler}
                  />
                  <Tooltip TransitionComponent={Zoom} title="Enter the reviewer's phone number">
                    <IconButton className="helpButton">
                      {/* <img className="helpImage" src={HelpIcon} alt="help"/> */}
                      <i class="zmdi zmdi-help"></i>
                    </IconButton>
                  </Tooltip>
                </div>
              </div>

              <div className="form__form-group input-field">
                <span className="form__form-group-label">Password</span>
                <div className="form__form-group-field selectEmply">
                  <TextField
                    name="password"
                    type="password"
                    placeholder="Enter Password"
                    onChange={this.onChangeHandler}
                  />
                  <Tooltip TransitionComponent={Zoom} title="Enter password for reviewer's login">
                    <IconButton className="helpButton">
                      {/* <img className="helpImage" src={HelpIcon} alt="help"/> */}
                      <i class="zmdi zmdi-help"></i>
                    </IconButton>
                  </Tooltip>
                </div>
              </div>

              <ButtonToolbar className="form__button-toolbar input-field">
                {loader ? (
                  <Button color="success" disabled>
                    <PulseLoader color={"#123abc"} size={12} />
                  </Button>
                ) : (
                  <Button color="success" type="submit">
                    Create Reviewer
                  </Button>
                )}
              </ButtonToolbar>
            </form>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

CreateReviewer.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    loader: state.createReviewerReducer.loader,
    reviewerAddStatus: state.createReviewerReducer.reviewerAddStatus
});

export default connect(
  mapStateToProps,
  { createReviewer }
)(withRouter(withStyles(styles)(CreateReviewer)));